// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../types';

import gql from 'graphql-tag';
import { UseDateTimeDurationEventFragmentDoc } from '../../../../Hooks/useDateTimeDuration/useDateTimeDuration.generated-types';
import { GetStatusesEventFragmentDoc } from '../../../../Graphql-Utilities/getStatuses/getStatuses.generated-types';
export type EventMenuItemEventFragment = { __typename?: 'Event', name: string, location: string, status: Types.EventStatus, fromDateTime: string, toDateTime: string, proposalCount: number, proposals: Array<{ __typename?: 'Proposal', UUID: string, invitationID: number, status: Types.ProposalStatus }>, invitations?: Array<{ __typename?: 'Invitation', ID: number, declinedAt?: string | null }> | null };

export const EventMenuItemEventFragmentDoc = gql`
    fragment EventMenuItemEvent on Event {
  name
  location
  status
  proposals {
    UUID
    invitationID
    status
  }
  invitations {
    ID
    declinedAt
  }
  ...UseDateTimeDurationEvent
  ...GetStatusesEvent
}
    ${UseDateTimeDurationEventFragmentDoc}
${GetStatusesEventFragmentDoc}`;